import { apiResponse, ApiService } from '@stores/index';

export class LeaderboardStore {
  constructor(private api: ApiService = new ApiService()) {}

  async readByCohortId(groupId: number) {
    try {
      const response = await this.api.get(`Cohort/${groupId}/leaderboard`);
      return apiResponse.Success(response);
    } catch (e) {
      return apiResponse.HandleError(e);
    }
  }
}
